'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLASS_HIDDEN = exports.PRODUCT_ID = exports.PRODUCTS_LOOP_SELECTOR = exports.PRODUCTS_SELECTOR = exports.CONTAINER_SELECTOR = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _CarouselSection2 = require('./../../sections/carousel/CarouselSection');

var _Responsive = require('./../../settings/Responsive');

var ResponsiveSizes = _interopRequireWildcard(_Responsive);

var _ShopifySection = require('./../ShopifySection');

var _pcSlateTools = require('@process-creative/pc-slate-tools');

var _ProductThumbnail = require('./../../objects/product/ProductThumbnail');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *  Product Recommendations
 *    Generates recommended products via Shopify's Product Recommendations API.
 *
 *  Version:
 *    1.0.0 - 2020/07/01
 */

var CONTAINER_SELECTOR = exports.CONTAINER_SELECTOR = '[data-product-recommendations]';
var PRODUCTS_SELECTOR = exports.PRODUCTS_SELECTOR = '[data-products-carousel]';
var PRODUCTS_LOOP_SELECTOR = exports.PRODUCTS_LOOP_SELECTOR = '[data-product-recommendations-loop-container]';

var PRODUCT_ID = exports.PRODUCT_ID = 'data-product-id';
var CLASS_HIDDEN = exports.CLASS_HIDDEN = 'is-hidden';

var ProductRecommendations = function (_CarouselSection) {
  (0, _inherits3.default)(ProductRecommendations, _CarouselSection);

  function ProductRecommendations(container) {
    (0, _classCallCheck3.default)(this, ProductRecommendations);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ProductRecommendations.__proto__ || Object.getPrototypeOf(ProductRecommendations)).call(this, container));

    _this.container = container;

    _this.productsLoopContainer = container.find(PRODUCTS_LOOP_SELECTOR);

    _this.fetchRecommendations().then(function (e) {
      return _this.onFetch(e);
    }).catch(function (e) {
      return _this.onFetchError(e);
    });
    return _this;
  }

  (0, _createClass3.default)(ProductRecommendations, [{
    key: 'fetchRecommendations',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var id;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                id = this.container.attr(PRODUCT_ID);

                //Fetch recommended products based on Shopify Recommended Product API.

                _context.next = 3;
                return (0, _pcSlateTools.ajaxRequest)('/recommendations/products', 'GET', {
                  section_id: 'product-recommendations-inner',
                  product_id: '' + id,
                  limit: 8
                });

              case 3:
                return _context.abrupt('return', _context.sent);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchRecommendations() {
        return _ref.apply(this, arguments);
      }

      return fetchRecommendations;
    }()
  }, {
    key: 'onFetch',
    value: function onFetch(e) {
      //If Shopify couldn't fetch anything, return.
      if (!e && !e.length) return;

      this.productsLoopContainer.html(e);
      this.products = this.container.find(PRODUCTS_SELECTOR);
      this.container.removeClass(CLASS_HIDDEN);
      this.initCarousel(this.products);
      (0, _ProductThumbnail.InitializeInactiveThumbnails)();
    }
  }, {
    key: 'onFetchError',
    value: function onFetchError(e) {
      console.error(e);
    }
  }, {
    key: 'optionOverrides',
    value: function optionOverrides() {
      var _ref2;

      return _ref2 = {
        infinite: this.container.data('infinite') === true ? true : false,
        autoplay: this.container.data('autoplay') == true,
        autoplaySpeed: this.container.data('autoplay-speed') * 1000 || 5000,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false
      }, (0, _defineProperty3.default)(_ref2, 'arrows', false), (0, _defineProperty3.default)(_ref2, 'adaptiveHeight', true), (0, _defineProperty3.default)(_ref2, 'arrows', true), (0, _defineProperty3.default)(_ref2, 'nextArrow', this.container.find(_CarouselSection2.NEXT_SELECTOR)), (0, _defineProperty3.default)(_ref2, 'prevArrow', this.container.find(_CarouselSection2.PREV_SELECTOR)), (0, _defineProperty3.default)(_ref2, 'responsive', [{
        breakpoint: ResponsiveSizes.small - 1,
        settings: {
          slidesToShow: 2
        }
      }, {
        breakpoint: ResponsiveSizes.medium - 1,
        settings: {
          slidesToShow: 3
        }
      }]), _ref2;
    }
  }]);
  return ProductRecommendations;
}(_CarouselSection2.CarouselSection);

(0, _ShopifySection.register)(CONTAINER_SELECTOR, ProductRecommendations);